<script>
import { companyNameResort } from "../utils/CompanyNameResorter";
import { usePartyStore } from "../stores/PartyStore";
import ShowAdress from "./ShowAdress.vue";

export default {
  data() {
    return {
      partyStore: null,
    };
  },

  computed: {
    party() {
      return this.partyStore.party;
    },
    showImprints() {
      return this.party.imprints && this.party.imprints.length > 0;
    },
    showIsbn() {
      return this.party.isbns.length > 0 ? true : false;
    },
    countImprints() {
      return this.party.imprints ? this.party.imprints.length : 0;
    },
    countStoreBranches() {
      return this.party.storeBranches.length;
    },

    setTriangleBG() {
      if (this.party.businessType == 1) return "publisher";
      if (this.party.businessType == 2) return "bookstores";
      if (this.party.businessType == 3) return "distributor";
      if (this.party.businessType == 11) return "singleISBNpublisher";
      if (this.party.businessType == 12) return "serviceprovider";
      return "";
    },

    companynameResorting() {
      return companyNameResort(this.party.companyName);
    },

    parentStorecompanynameResorting() {
      return companyNameResort(this.party.parentStore.companyName);
    },    
  },
  methods: {
    sortISBN(isbnarray) {
      isbnarray.sort((a, b) => {
    // extract isbn and isbnprefix
    const isbnA = a.isbn || a.isbnPrefix || '';
    const isbnB = b.isbn || b.isbnPrefix || '';

      if (isbnA < isbnB) {
        return -1;
      }
      if (isbnA > isbnB) {
        return 1;
      }
      return 0;
    });   
    },

  },
  
  components: {
    ShowAdress,
  },
  props: {
    templatename: String,
    ZWEcounter: Number,
    NoZWEcounter: Number,
    showZWEStoreBranches:Boolean,
    showStoreBranches:Boolean,
    ImprintsArrayCounter:Number
  },  
  async created() {
    this.partyStore = usePartyStore();
  },
};
</script>
<template>
  <div>
    <div class="mb-0">
      <div class="grid grid-cols-1 md:grid-cols-2">
        <div class="">
          <h1 class="font-bold text-lg mt-8">
            {{ $t("Fullentry.ProfilView") }}
          </h1>
        </div>
        <div class="text-right triangle" :class="setTriangleBG">
          <div class="w-full font-bold mt-8 pr-2 text-lg">
            {{ this.$route.params.businessType }}
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 bg-adb-red">
      <div class="p-2 text-white">
        <h2 v-if="party.parentStore && companynameResorting == ''" class="text-white text-center">
          {{ parentStorecompanynameResorting }} parentstor
        </h2>
        <h2 v-else class="text-white text-center">
          {{ companynameResorting }}
        </h2>
        <h2 class="text-white text-center">{{ party.companyNameAddendum }}</h2>
    
        <template  v-for="contacts in party.contacts" :key="contacts.type">
          <p class="text-white text-center p-2" v-if="contacts.type == 'URL' && templatename!='shortshort'">
            {{ contacts.value }}
          </p>
        </template>

        <!-- if the company is an imprint from another then show this -->
        <template v-if="party.imprintHolder">
          <div class="text-center text-white">
            <router-link
              class="text-center bg-gray-200 text-black w-20 rounded-sm p-1"
              v-if="party.imprintHolder"
              :to="{
                path: '/party/' + party.imprintHolder.id,
              }"
              >{{ party.imprintHolder.companyName }}</router-link
            >
          </div>
        </template>

        <!-- if the company has a PARENTSTORE then show this link  -->
        <template v-if="party.parentStore">
          <div class="text-center text-white">
            {{ $t("Fullentry.aBranchFrom") }}
            <router-link
              class="text-center bg-gray-200 text-black w-20 rounded-sm p-1"
              v-if="party.parentStore"
              :to="{
                path: '/party/' + party.parentStore.id,
              }"
              >{{ parentStorecompanynameResorting }}</router-link
            >
          </div>
        </template>

        <!-- if the company HAS imprints show this button -->
        <div class="text-center mb-2 float" v-if="showImprints">
          <button
            class="text-center bg-gray-200 text-black rounded-sm p-1"
            @click="$emit('openImprints')"
          >
            {{ ImprintsArrayCounter }} {{ $t("Fullentry.Imprints") }}
          </button>
        </div>

        <!-- if the company HAS stores and businesstype=2 (Publisher) show this button -->

        <div
          class="text-center float"
          v-if="showStoreBranches && this.party.businessType == '2'"
        >
          <button
            class="text-center bg-gray-200 text-black rounded-sm p-1 mr-5"
            @click="$emit('openBranches')"
            v-if="showStoreBranches"
          >
          {{ NoZWEcounter }} {{ $t("Fullentry.Stores") }}
          </button>

          <button
            class="text-center bg-gray-200 text-black rounded-sm p-1"
            @click="$emit('openZweBranches')"
            v-if="showZWEStoreBranches"
          >
          {{ ZWEcounter }} {{ $t("Fullentry.ZWEStores") }}
          </button>          
        </div>
      </div>
      <div class="bg-footer-grey text-white text-lg p-2">
        <template v-if="templatename=='shortshort'">
          <!-- if isbns exist - show them -->
          <template v-if="showIsbn">
              <div class="">
                <p class="text-center pb-1 ">
                  {{ $t("Fullentry.IsbnNumbreSingleIsbn") }}
                </p>

                <div class="text-base text-center grid md:grid-cols-3">
                  {{sortISBN(party.isbns)}}

                  <p v-for="isbn in party.isbns" :key="isbn.id">
                    <span class="whitespace-nowrap" v-if="isbn.isbnPrefix">{{ isbn.isbnPrefix }}</span>   
                    <span class="whitespace-nowrap" v-if="isbn.isbn">{{ isbn.isbn }}</span>         
                  </p>            
                </div>
              </div>
            </template>  
        </template>
        
        <template v-if="templatename!='shortshort'">
          <ShowAdress />
        </template>
      </div>
    </div>

  </div>
</template>
<style>
.triangle {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom left, 50%, 50%;
  height: 100%;
  width: 100%;
  min-height: 70px;
}
.publisher {
  background-image: url("../assets/triangle-publisher.svg");
}
.bookstores {
  background-image: url("../assets/triangle-bookstores.svg");
}
.distributor {
  background-image: url("../assets/triangle-distributor.svg");
}
.serviceprovider {
  background-image: url("../assets/triangle-serviceprovider.svg");
}
.singleISBNpublisher {
  background-image: url("../assets/triangle-singleISBNpublisher.svg");
}

.triangleword {
  margin-left: -50px;
}
</style>